import { render, staticRenderFns } from "./selectAttributeValues.vue?vue&type=template&id=8968710a"
import script from "./selectAttributeValues.vue?vue&type=script&lang=js"
export * from "./selectAttributeValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports